export default __webpack_public_path__ + "static/media/boite6.3f5eaf66.jpg";